import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { JournalPerYear } from 'src/app/shared/models/JournalPerYear';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { CashflowVO } from 'src/app/shared/vo/CashflowVO';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';

@Component({
  selector: 'app-fv-summary-matter-dtl',
  templateUrl: './fv-summary-matter-dtl.component.html',
  styleUrls: ['./fv-summary-matter-dtl.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class FvSummaryMatterDtlComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  currencies: any[];

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = false;

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetLstFVDetail = "listFVDetailMater";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";
  endPointGetStoreById = "getStoreById";
  endPointFindByJournalPerByYear = "findFiiJournalPerbyYear";
  endPointSearchCategory = "searchCategory";

  /** DATAPARENT */
  dataParent: any = {};

  responseFile?: ResponseFile;

  // DATA
  dataI: CashflowVO[] = [];
  colsI: string[];
  rowsI: number = 12;


  cols = [
    { field: "docId", header: "lbl_document_id", type : "string"},
    { field : "date", header : "lbl_date", type : "string"},
    { field: "userId" , header: "lbl_user", type : "string"},
    { field: "menuOption" , header: "Opcion", type : "string"},
    { field: "comments", header: "lbl_description", type : "string" },
    { field: "amount", header: "lbl_amount", type : "float" },
    { field: 'balance', header: 'Saldo Actual', type : "float"},
  ];

  globalFilter = [
    'date',
    'docId',
    'userId',
    'menuOption',
    'unitDescription',
  ]

  // JOURNAL MONTH VALIDATOR 
  journalMonthValidator: JournalPerYear[] = [];

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(
    private tovpilUtils: TovpilUtilsService,
    private messageService: MessageService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private filesService: TovpilFilesService,
    private router: Router,
    private route: ActivatedRoute,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private urlBuilderService: UrlBuilderService
  ) {

    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.currCode = params.currCode;
      this.dataParent.type = params.type;
      this.dataParent.storeId = params.storeId;
      this.dataParent.conceptId = params.conceptId;
      this.dataParent.unitType = params.unitType;
      this.dataParent.unitId = params.unitId;
      this.dataParent.date = params.date;
      this.dataParent.year = params.year;
      this.dataParent.period = params.period;
    });

    this.createDataForm();
    this.initConfigs();

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }

  }

  /**
    * The function initializes form groups for configuration and data, and updates the configuration form
    * with query parameters from the route.
    */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    // console.debug("FiiList() Preferencuas de usuario: " + JSON.stringify(this.globalUserPreferences, null, 2));

    if(this.dataParent?.date?.length > 0){
      let date = this.dataParent.date;
      this.globalUserDataForm.patchValue({
        selectedDate : this.tovpilUtils.stringToDate(date),
      });

      this.dataParent.date = "";
    }
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: true }),
      selectedCurrency: new FormControl({ value: null, disabled: true }),
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedUnit: new FormControl({ value: null, disabled: true }),
      selectedConcept: new FormControl({ value: null, disabled: true }),
      selectedDate: new FormControl(null),
      selectedMinDate : new FormControl(null),
      selectedMaxDate : new FormControl(null)
    });
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.preferences.currentUser = currentUser;

    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.cols = this.tovpilUtils.translateCols(this.cols, this.translations);

      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    // console.debug("FiiList() Debug > Material Languages");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
    }
  }

  /**
    * This TypeScript function asynchronously fetches a list of currencies based on store ID and language
    * ID, handling errors and returning the data if successful.
    * @returns The function returns either the fetched currency data if
    * successful, or `null` if there are missing parameters, an error occurred during fetching, or an
    * exception was caught.
    */
  async getListCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        let lstCurrencies = result.data;

        let currencySelected = currency ? lstCurrencies.find(o => o.valueId === currency) ?? lstCurrencies[0] : lstCurrencies[0] ?? null;
        this.currencies = lstCurrencies;

        this.globalUserDataForm.patchValue({
          selectedCurrency: currencySelected
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string, formControlName: string) {
    try {
      if (!storeId || !formControlName) {
        console.warn('Missing required parameters: storeId and formControlName are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, { storeId });

      if (result.success) {
        const storeDescription = result.data?.storeId + ' ' + result.data?.descri;
        this.globalUserDataForm.patchValue({ [formControlName]: storeDescription });
        return true;
      } else {
        console.error("An error occurred while fetching store data:");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }


  async getConcept(conceptId: string, language: string) {
    try {
      const concept = await this.apiService.getFiiconceptByIdTrans({
        concepId: conceptId,
        language: language
      });

      if (concept == null)
        throw Error("concept not found");

      const conceptDesc = `${concept.concepId} - ${concept.descrip}`;
      this.globalUserDataForm.patchValue({ selectedConcept: conceptDesc });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }


  async getUnit(unitType: string, unitId: string, language: string) {
    try {
      let unitObject = {
        id: "",
        descrip: ""
      }
      if ((unitType != 'P' && unitType != 'S') || unitType == null)
        throw Error("Tipo no es valido");

      if (unitId == null || unitId == '')
        throw Error("Id destino no es valido");

      if (language == null || language == '')
        throw Error("Lenguaje no es valido");

      switch (unitType) {
        case 'P':
          let guide = await this.apiService.getGuideById({
            guideId: unitId
          });
          unitObject.id = guide.guideId;
          unitObject.descrip = `${guide.name} ${guide.lastName}`;
          break;
        case 'S':
          let store = await this.apiService.getStoreById({
            storeId: unitId
          });
          unitObject.id = store.storeId
          unitObject.descrip = store.descri;
          break;
      }

      const unitDesc = `${unitObject.id} - ${unitObject.descrip}`;
      this.globalUserDataForm.patchValue({ selectedUnit: unitDesc });
      return true;
    } catch (error) {
      console.error("Erorr on getUnit(): " + error);
      return false;
    }
  }


  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {

      const language = this.globalUserPreferences?.preferences?.language || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const conceptId = this.dataParent.conceptId || null;
      const unitId = this.dataParent.unitId || null;
      const unitType = this.dataParent.unitType || null;
      const coordinationStoreId = this.dataParent.storeId || null;

      const validCurrencyResponse = await this.getListCurrencyByStoreId(coordinationStoreId, language, currency);
      const validCoordinationResponse = await this.getCoordination(coordinationStoreId, 'selectedCoordination');
      const validConceptResponse = await this.getConcept(conceptId, language);
      const validUnitResponse = await this.getUnit(unitType, unitId, language);
      const validStartingDate = await this.setStartingDate();

      if (validCurrencyResponse && validCoordinationResponse && validConceptResponse && validUnitResponse) {
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validCurrencyResponse, validCoordinationResponse, validConceptResponse, validUnitResponse);
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  setStartingDate(){
    const year = this.dataParent.year;
    const period = this.dataParent.period;

    if(period === '1'){
      this.globalUserDataForm.patchValue({
        selectedDate :new Date(year, 0, 1),
        selectedMinDate: new Date(year, 0, 1),
        selectedMaxDate : new Date(year, 5, 30)
      });
    }

    if(period === '2'){
      this.globalUserDataForm.patchValue({
        selectedDate : new Date(year, 6, 1),
        selectedMinDate: new Date(year, 6, 1),
        selectedMaxDate : new Date(year, 11, 31)
      });
    }
  }

  /**
   * The function `getListFII` is an asynchronous function that fetches data from an API endpoint and
   * handles the success and error cases.
   * @returns a Promise.
   */
  async getListIncome(storeId: string, language: string, currencyId: string, conceptId: string, unitId: string, unitType: string, type: string, date: string) {
    try {
      let data = await this.apiService.getFVDetail({
        storeId: storeId,
        language: language,
        currencyId: currencyId,
        conceptId: conceptId,
        unitId: unitId,
        unitType: unitType,
        date: date,
        type: type
      });
      if (data == null)
        throw Error("Error al obtener movimientos");      

      this.dataI = data.flows.map((e) => {
        return {
          ...e,
          date : this.tovpilUtils.formatStringDate(e.date),
        }
      });

      //data.flows = [nuevoElemento, ...data.flows];
      //this.dataI = this.acumulateAmounts(data.flows);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    if (this.globalUserDataForm.invalid) {
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return;
    }

    try {
      this.blocked = true;

      const language = this.globalUserPreferences?.preferences?.language || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const conceptId = this.dataParent.conceptId || null;
      const unitId = this.dataParent.unitId || null;
      const unitType = this.dataParent.unitType || null;
      const coordinationStoreId = this.dataParent.storeId || null;
      const type = this.dataParent.type || null;
      const date = this.tovpilUtils.dateToTovpilDate(this.globalUserDataForm.get('selectedDate').value);
      

      console.log(date);

      const incomeResponse = await this.getListIncome(coordinationStoreId, language, currency, conceptId, unitId, unitType, type, date);

      if (incomeResponse) {
        // console.debug("FiiList() 2.- Loading Data: ", incomeResponse);
        this.blocked = false;
      } else {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * This TypeScript function asynchronously reloads a list amount and handles any errors that may occur.
   */
  async reloadGetListIncome() {
    try {
      this.blocked = true;
      const language = this.globalUserPreferences?.preferences?.language || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const conceptId = this.dataParent.conceptId || null;
      const unitId = this.dataParent.unitId || null;
      const unitType = this.dataParent.unitType || null;
      const coordinationStoreId = this.dataParent.storeId || null;
      const type = this.dataParent.type || null;
      const date = this.tovpilUtils.dateToTovpilDate(this.globalUserDataForm.get('selectedDate').value);


      const incomeResponse = await this.getListIncome(coordinationStoreId, language, currency, conceptId, unitId, unitType, type, date);

      if (incomeResponse) {
        this.blocked = false;
      } else {
        //this.handleError('INCOME List', 'Hubo un problema al procesar los INCOME. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('INCOME List', 'Hubo un problema al procesar los INCOME. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function "capitalizeLastElement" takes a string as input and returns the same string with the
   * last element capitalized.
   * @param {string} str - The parameter `str` is a string that represents the input string.
   * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
   * with the `str` parameter.
   */
  capitalizeLastElement(str: string): string {
    if(str == this.translations.lbl_amount || str == "Saldo Actual"){
      return this.tovpilCrudService.capitalizeLastElement(str) + ` (${this.dataParent.currCode})`;
    }
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    let value = this.tovpilCrudService.getNestedValue(obj, field);
    return this.isNumeric(value) ? (parseFloat(value).toFixed(2)) : value;
  }

  /**
   * The `exportExcel()` function exports data to an Excel file if the data is not null and not empty,
   * otherwise it displays an error message.
   */
  exportExcel() {
    if (this.dataI === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
    } else if (this.dataI.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.translations.lbl_list} ${this.translations.lbl_no_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.dataI.map((item) => {
        return {
          [this.translations.lbl_document_id]: item.docId || '',
          [this.translations.lbl_date]: item.date || '',
          [this.translations.lbl_description]: item.unitDescription|| '',
          [this.translations.lbl_amount + `(${item.currencyId})`]: item.amount || '',
          [`ACUMULADO (${item.currencyId})`]: item.balance || '',
        };
      });
      this.filesService.tovpilExportXLSX(filteredJSON, 'CXC2Detail_');
    }
  }
  

  /**
   * The function `exportPdf` generates a PDF file based on provided data and column filters.
   * @param {any[]} _data - The `_data` parameter is an array containing the data that will be used to
   * generate the PDF. It is expected to be an array of objects where each object represents a row of
   * data to be included in the PDF.
   * @param {any[]} _colsFilter - The `_colsFilter` parameter is an array containing objects with
   * properties `name` and `value`. It is used to filter and map the data in the `_data` array to
   * generate a PDF. Each object in `_colsFilter` specifies a column name and the corresponding value to
   * extract from the data
   * @param {string} _name - The `_name` parameter in the `exportPdf` function is a string that
   * represents the name of the PDF file that will be generated. It is used as a reference to name the
   * PDF file when it is exported.
   */
  exportPdf() {
    if (this.dataI === null) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
    } else if (this.dataI.length < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: `${this.translations.lbl_list} ${this.translations.lbl_no_valid}`,
        life: 3000
      });
    } else {
      const filteredJSON = this.dataI.map((item) => {
        return {
          [this.translations.lbl_document_id]: item.docId || '',
          [this.translations.lbl_date]: item.date || '',
          [this.translations.lbl_description]: item.unitDescription|| '',
          [this.translations.lbl_amount + `(${item.currencyId})`]: item.amount || '',
          [`ACUMULADO (${item.currencyId})`]: item.balance || '',
        };
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'CXC2Detail_');
    }
  }

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    // console.debug("FiiList() onChangeUserPreferences")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    this.loadData();
  }

  getDownloadLabel(string : string){ 
    let stringRet = string.split(",");
    return stringRet[1] + "-" + stringRet[2];
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage').value)?.valueId || null;
    let currency = (this.globalUserDataForm.get('selectedCurrency').value)?.valueId || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      currency || null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      null, //_selYear
      null, //_selPeriod
      null, //_device
      null, //_storeSelected
      null, //_periodSelected
      null //_stores
    );
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {

    try {
      let queryParams = {
        module: 'treasurer',
        view: 'receivableLstH'
      };

      let navigationExtras: NavigationExtras = {
        queryParams: queryParams
      };

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigate(['/treasurer/receivableLstH'], navigationExtras);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /**
 * The function shouldApplyVerticalStyle determines whether a given label should have a vertical style
 * applied based on its length exceeding 15 characters.
 * @param {string} label - The `label` parameter is a string that represents the text content of a
 * label. The `shouldApplyVerticalStyle` function checks if the length of the `label` is greater than
 * 15 characters and returns a boolean value accordingly.
 * @returns The function shouldApplyVerticalStyle is returning a boolean value based on whether the
 * length of the input label is greater than 15.
 */
  shouldApplyVerticalStyle(label: string): boolean {
    return label.length > 15;
  }

  /**
 * The function isNumeric checks if a value is a numeric type in TypeScript.
 * @param {any} value - The `value` parameter in the `isNumeric` function is of type `any`, which means
 * it can be any data type in TypeScript. The function checks if the value is numeric by ensuring that
 * it is not `NaN`, is finite, and is not a string.
 * @returns The function `isNumeric` returns a boolean value indicating whether the input `value` is a
 * numeric value or not.
 */
  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value) && typeof value !== 'string';
  }

  /**
   * The function `getTabHeader` returns a string composed of 'DIE', the selected type description,
   * and the selected month description.
   * @returns The `getTabHeader()` function is returning a string that concatenates the text 'DIE',
   * the value of '' from the globalUserDataForm, and the value of
   * 'selectedMonthDescription' from the globalUserDataForm.
   */
  getTabHeader(): string {

    const typeValue = this.dataParent.type ?? null;

    return '' + (typeValue == 'AR' ? 'Cuentas por Cobrar' : 'Cuentas por Pagar');
  }

  redirectToRecPay(opt: string, rowData: CashflowVO) {
    try {

      const queryParams = {
        currCode: this.dataParent.currCode ?? null,
        type: this.dataParent.type ?? null,
        storeId: this.dataParent.storeId ?? null,
        conceptId: this.dataParent.conceptId ?? null,
        unitId: this.dataParent.unitId ?? null,
        unitType: this.dataParent.unitType ?? null,
        opt: opt.toLowerCase() ?? null,
        sequence: rowData?.sequence ?? null,
        date :  this.tovpilUtils.dateToTovpilDate(this.globalUserDataForm.get('selectedDate').value),
        period: this.dataParent.period
      };

      let navigationExtras: NavigationExtras = {
        queryParams: queryParams
      };

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigate(['/treasurer/receivableRecPay'], navigationExtras);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  /**
  * The  function exports data to an Excel file if the data is not null and not empty,
  * otherwise it displays an error message.
  */
  async dwnRemitionXls(rowData) {
    this.blocked = true;
    const number = rowData.dwdDocum;
    try {
      const language = this.globalUserPreferences?.preferences?.language || null;
      const storeId = this.dataParent.storeId ?? null;
      const year = number.split(',')[1];
      const sequence =  number.split(',')[2];
      const userId = this.globalUserPreferences?.preferences?.userId;


      // FALTAN LOS DATOS DEL REQUEST
      await this.apiService.dwnRemitionXls(
        {
          "language": language,
          "storeId": storeId,
          "year": year,
          "sequence": sequence,
          "userId": userId
        }
      ).then(
        data => {
          this.responseFile = data;
          const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
          const link = document.createElement("a");
          link.href = source;
          link.download = this.responseFile.nameFile
          link.click();
        })
    } catch (error) {
      console.error("An error occurred while exporting excel:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}: ${error}` });
    } finally {
      this.blocked = false;
    }
  }

  /**
 * The function  asynchronously fetches data based on field ID, field value, and
 * language, handling errors and returning a default value if needed.
 * @param {string} _fieldId - The `_fieldId` parameter is a string representing the ID of a field in
 * the data form.
 * @param {string} _fieldValue - The `_fieldValue` parameter in the  function represents
 * the value associated with the field specified by the `_fieldId` parameter. This function is designed
 * to fetch data based on the provided field ID and field value, and it returns the corresponding value
 * from the fetched data. If an error
 * @returns The function  returns a Promise that resolves to either the fetched data
 * value if the fetch operation is successful, or the string "S/N" if there is an error during the
 * fetch operation or if the result is not successful.
 */
  async getTypeDescri(_fieldId: string, _fieldValue: string) {
    try {
      let language = this.globalUserPreferences?.preferences?.language ?? null;

      let result = await this.tovpilCrudService.fetch(this.endPointSearchCategory, {
        fieldId: _fieldId,
        fieldVal: _fieldValue,
        language: language,
        zoneId: null
      });

      if (result.success) {
        return result.data['value'];
      } else {
        console.error("An error occurred while fetching purchase order data:");
        return "S/N";
      }
    } catch (error) {
      console.error(error);
      return "S/N";
    }
  }

  acumulateAmounts(arr) {
    let acumulado = 0;
    return arr.map(obj => {
      if (obj.hasOwnProperty('amount')) {
        acumulado += obj.amount;
        return { ...obj, acc: acumulado }; // Crea un nuevo objeto con el acumulado
      } else {
        console.warn("Objeto sin llave 'importe'", obj);
        return { ...obj, acc: acumulado }; // Devuelve un nuevo objeto sin modificar el acumulado
      }
    });
  }

}
